// extracted by mini-css-extract-plugin
export default {"customClass":"drawer_customClass__DoeAT"};